/* eslint-disable react/jsx-no-target-blank */
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import * as MaterialIcons from '@material-ui/icons'
import ElderlyIcon from '@mui/icons-material/Elderly'
import KeyIcon from '@mui/icons-material/Key'
import AddReactionIcon from '@mui/icons-material/AddReaction'
import HomeIcon from '@mui/icons-material/Home'
import {PsychologyAlt, MarkChatUnread, Apps} from '@mui/icons-material'
import {useMenuContext} from '../../../../app/pages/contexts/MenuContext'

const menuicn: any = {
  Dashboard: MaterialIcons.Dashboard,
  Home: HomeIcon,
  Assignment: MaterialIcons.Assignment,
  key: KeyIcon,
  AddReaction: AddReactionIcon,
  Elderly: ElderlyIcon,
  EnhancedEncryption: MaterialIcons.EnhancedEncryption,
  PsychologyAlt: PsychologyAlt,
  ContactSupport: MaterialIcons.ContactSupport,
  MarkChatUnread: MarkChatUnread,
  Apps: Apps,
}
const AsideMenuMain = () => {
  const {fullMenu} = useMenuContext()
  return (
    <>
    {/* removed container */}
      {/* <ToastContainer /> */}
      {fullMenu &&
        fullMenu.map((item: any) => {
          return (
            <>
              {item['submenu'].length <= 0 ? (
                <AsideMenuItem
                  key={item.itemId}
                  to={String(item.path)}
                  icon={menuicn[item.icon]}
                  title={item.name}
                  supportCount={item.supportCount}
                  menuId={item.menuId}
                  fontIcon='bi-app-indicator'
                  hasMain=''
                />
              ) : (
                <AsideMenuItemWithSub to='' title={item.name} icon={menuicn[item.icon]} >
                  {item.submenu.map((submenu: any) => {
                    return (
                      <>
                        {submenu['submenu'].length <= 0 ? (
                          <AsideMenuItem
                            to={String(submenu.path != null ? submenu.path.trim() : '')}
                            title={submenu.name}
                            hasBullet={true}
                            hasMain={item.name}
                            menuId={submenu.menuId}
                          />
                        ) : (
                          <AsideMenuItemWithSub
                            to=''
                            title={submenu.name}
                            icon={menuicn[item.icon]}
                          >
                            {submenu['submenu'] &&
                              submenu['submenu'].map((subsubmenu: any) => {
                                return (
                                  <AsideMenuItem
                                    to={String(
                                      subsubmenu.path != null ? subsubmenu.path.trim() : ''
                                    )}
                                    title={subsubmenu.name}
                                    hasBullet={true}
                                    hasMain={submenu.name}
                                    menuId={subsubmenu.menuId}
                                  />
                                )
                              })}
                          </AsideMenuItemWithSub>
                        )}
                      </>
                    )
                  })}
                </AsideMenuItemWithSub>
              )}
            </>
          )
        })}
    </>
  )
}

export {AsideMenuMain}
